module.exports = __webpack_public_path__ + "img/ImagineerTypesQuiz_Innovation Imagineer.37cfd7aa.png";